<template>
    <div class="message-header metric-input" v-bind:class="{ completed: completed }">
        <div class="metric-description" v-if="!completed">
            <img :src="iconFile" />
            <div>
              <h2> {{ title }} </h2>
                <p> {{ description }} </p>
                <p class="subheading"> {{ subheading }} </p>
            </div>
        </div>
        <div class="metric-description completed" v-else>
            <div class="metric-background"> </div>
            <img :src="iconFile" />
            <div>
                <h2> {{ title }} </h2>
                <div class="overall-rating" v-if="!hideStars" >
                    <p> {{ starRating }} </p>
                    <div class="stars-container">
						<StarRating v-model="starRating" active-color="rgba(250, 250, 250, 1)" inactive-color="rgba(250, 250, 250, 0.4)" :star-size="25" :star-points="svgStar"></StarRating>
                    </div>
                </div>
            </div>
        </div>
        <div class="stars-container" v-if="!completed && !hideStars">
			<StarRating v-model="starRating" active-color="#E3C855" :star-size="30" :star-points="svgStar"></StarRating>
        </div>
        <div class="completed-container completed" v-else-if="!hideStars">
            <div class="metric-background">
                <img src="@/assets/visuals/completed-metric-texture.svg"/>
            </div>
            <p> Completed </p>
        </div>
    </div>
</template>

<script>
import StarRating from 'vue-star-rating';
export default {
    name: "MetricInputCard",

	components: {
		StarRating
	},

    props: {
        title: String,
        subheading: String,
        description: String,
        icon: String,
        selector: String,
		completed: Boolean,
		hideStars: Boolean
    },

    data() {
        return {
            starRating: 0,
			svgStar: [8.41408402557373,0.003816786193847656,8.853152776932717,0.8933119033002854,9.299495749482514,1.7975436287623645,9.742359239768982,2.694726384162903,10.181986730208994,3.5853534326189758,10.628049577903747,4.489017662239075,11.133008589172363,5.283785730047225,12.132366308593749,5.429857210083007,13.11015419921875,5.5727759283447265,14.105211274647711,5.7182188032065335,15.09610646727085,5.863053354973048,16.08820486316681,6.008063773378134,16.643669140625,6.2917013671875,15.932394371795654,6.9844810642242425,15.210241094207763,7.68785639930725,14.499909470427038,8.379717475622893,13.778769472078979,9.082105879472644,13.06842637863159,9.773978127212526,12.683427258300782,10.592140600585939,12.851020599356294,11.569335060280562,13.02202841796875,12.5664384765625,13.189948238396646,13.545536555051804,13.360425108337402,14.539544143676757,13.526271482276917,15.506552479171752,13.167661761951447,15.76690069770813,12.272105572783946,15.295927065610886,11.391103743489085,14.83260758164525,10.496755492055415,14.362269204854964,9.617953173828125,13.900106445312499,8.737401968133451,13.437023944616318,7.855843753204346,13.558585891723633,6.96406107584238,14.027571422815322,6.086530515611171,14.489061813116074,5.193711093871892,14.958592564612626,4.315979041290284,15.420188919067382,3.423695615541935,15.88943779206276,3.343230344848633,15.243372372817994,3.511284730606079,14.26352916378975,3.680713541488647,13.275672351789474,3.8477341796875004,12.301856420898437,4.019392008743287,11.301003290414812,4.188870874023437,10.312854635620118,3.5672839414954187,9.590194890431167,2.8521112409234046,8.89361861844182,2.1400159835353496,8.200039767772704,1.4239935874938965,7.502635894699097,0.7040065726861358,6.801370493692607,0.016674988403320313,6.113232706909179,1.012517713394165,5.9676757485198975,2.0004463325607778,5.8232755522811415,2.9915530497135223,5.678410830606072,3.9736142578124998,5.534868242187501,4.967594610973745,5.389583496640771,5.877084446411133,5.135867502441407,6.320185375554413,4.2381933672064545,6.765979454087019,3.335063205161095,7.203832169847489,2.4480213776016235,7.646362358932496,1.5515034994506836,8.093466215209961,0.6457198706054688]
		}
    },

    computed: {
        iconFile() {
            return require(`@/assets/icons/metrics/${this.icon}-icon${this.completed ? "-white" : ""}.svg`);
        }
    },

    methods: {
        updateStars(index) {
            this.starRating = index;
			this.$emit('updateStars', this.starRating);
        },

        highlightStars(index, query) {
			let stars = document.querySelectorAll("." + query);

			for (let i = 1; i <= 5; i++) {
				if (i > index) {
					stars[i - 1].classList.add("transparent");
				} else {
					stars[i - 1].classList.remove("transparent");
				}
			}
        },

		deselectStars(query) {
			let stars = document.querySelectorAll("." + query)
			for (let i = 1; i <= 5; i++) {
				if (i <= this.starRating) {
					stars[i - 1].classList.remove("transparent");
				} else {
					stars[i - 1].classList.add("transparent");
				}
			}
        }
    },
	watch: {
		starRating: function (newVal) {
			this.updateStars(newVal);
		}
	}
};
</script>
<style lang="scss">
	.vue-star-rating-star {
		margin: 0 1.5px;
	}
	.vue-star-rating-rating-text {
		display: none;
	}
</style>
<style lang="scss" scoped>
@import "@/styles/_main.scss";

.stars-container {
  img {
    cursor: pointer;
  }
}

.metric-input {
    background: #FAFAFA;
    border-radius: 12px;
    padding: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.completed {
        background-color: #E3C855;
        color: white;
        position: relative;
        margin: -36px;
        padding: 36px;

        .stars-container {
            img {
                margin: 0 1.5px;
                height: 24px;
            }
        }

        .overall-rating {
            display: flex;

            > p {
                font-size: 20px;
                font-weight: 700;
                margin-right: 10px;
                color: white;
            }
        }
    }

    .metric-description {
        display: flex;

        &.completed {
            .metric-background {
                display: block;
                position: absolute;
                height: 100%;
                min-width: 90px;
                width: 425px;
                background-color: rgba(250, 250, 250, 0.2);
                top: 0;
                left: 0;
                border-top-right-radius: 80px;
                border-bottom-right-radius: 80px;
				z-index: -10;
            }

            h2 {
                color: white;
                font-weight: 700;
            }
        }

        h2 {
            font-size: 24px;
            color: #504141;
        }

        p {
            margin: 0;
            color: #999999;
            font-size: 14px;
        }

        img {
            margin-right: 32px;
        }
    }

    .stars-container {
        display: flex;
        justify-content: space-evenly;

        img {
            margin: 0 2.5px;
            height: 35px;

            &.transparent {
                opacity: 0.4;
            }
        }
    }

    .completed-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 25%;
        font-weight: 700;
        position: relative;

        .metric-background {
            position: absolute;

        }

        p {
            font-size: 18px;
        }

        svg {
            margin-right: 12px;
            height: 24px;
        }
    }
}

@media only screen and (max-width: $breakpoint-large) {
    .metric-input .stars-container img {
        height: 25px;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    .metric-input {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        > .metric-description {
            display: flex;
            justify-content: center;
            align-items: center;
            p {
                display: none;
            }

            h2 {
                font-size: 20px;
            }

            > img {
                height: 28px;
                margin-right: 10px;
            }
        }
    }
}
</style>
